module.exports = __webpack_public_path__ + "static/media/instagram.f13a20d9.svg";